/**
 * Studio Home 筛选 end_time + date_type → overall_performance 常用日期区间
 *（与 StudioBundlePerformanceBlock net_revenue / filter_range 一致）
 */

/** 本地日历 YYYY-MM-DD（与筛选展示一致，避免 toISOString 时区偏移） */
export function formatLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * 日=选中日；周=选中日所在自然周（周一至周日）；月=选中日所在自然月
 */
export function computeFilterDateRangeFromEnd(
  endTime: unknown,
  dateType: unknown,
): { start: string; end: string; } | null {
  if (endTime === null || endTime === undefined) {
    return null;
  }
  const ed = new Date(endTime as string | number | Date);
  if (Number.isNaN(ed.getTime())) {
    return null;
  }
  const y = ed.getFullYear();
  const mo = ed.getMonth();
  const dom = ed.getDate();

  if (dateType === 'monthly') {
    const start = new Date(y, mo, 1);
    const end = new Date(y, mo + 1, 0);
    return { start: formatLocalYmd(start), end: formatLocalYmd(end) };
  }
  if (dateType === 'weekly') {
    const sd = new Date(y, mo, dom);
    const dow = sd.getDay() || 7;
    sd.setDate(sd.getDate() - dow + 1);
    const weekEnd = new Date(sd);
    weekEnd.setDate(weekEnd.getDate() + 6);
    return { start: formatLocalYmd(sd), end: formatLocalYmd(weekEnd) };
  }
  const anchor = new Date(y, mo, dom);
  const endStr = formatLocalYmd(anchor);
  return { start: endStr, end: endStr };
}
